import React, { Fragment } from 'react';
import './_categories.scss';
import HighLightTags from 'components/mweb/HighlightTags/HighlightTags';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import ImageOverlay from '../../common/ImageOverlay/ImageOverlay';
import AnalyticsService from 'AnalyticsService';

const CategoryCard = ({
  category,
  deviceType,
  getSelectedCategory,
  selectedCategory,
  isCategoriesLink,
}) => {
  const categoryImageUrl =
    deviceType === DEVICE_TYPE.DESKTOP
      ? category.desktopImage
      : category.mobileImage;

  const {
    categoryId,
    categoryDisplayName,
    isProvisional,
    mobileBannerImage,
  } = category;
  return (
    <Fragment>
      <div
        className={`${
          isCategoriesLink
            ? 'desktop-categories-link-card'
            : 'category-card-desktop'
        } ${
          selectedCategory === category.categoryName
            ? isCategoriesLink
              ? 'desktop-categories-link-card--selected'
              : 'category-card-desktop--selected'
            : ''
        }`}
        onClick={() => {
          getSelectedCategory(category.categoryName);
          // Clevertap Analytics
          const key = 'View Category';
          const payload = {
            categoryId,
            categoryDisplayName,
            isProvisional,
            mobileBannerImage,
          };
          AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
        }}
      >
        <div
          className={`${
            isCategoriesLink
              ? 'desktop-categories-link--img-container'
              : 'category-card-desktop--image-container'
          }`}
        >
          <ImageOverlay>
            <img
              src={categoryImageUrl}
              className={`${
                isCategoriesLink
                  ? 'desktop-categories-link--img'
                  : 'category-card-desktop--image'
              }`}
              alt={category.categoryName}
            />
          </ImageOverlay>
          {category.tags &&
            category.tags.length > 0 &&
            category.tags.indexOf('bestseller') > -1 && (
              <HighLightTags type="bestseller" />
            )}
        </div>

        <div
          className={`${
            isCategoriesLink
              ? 'desktop-categories-link--details'
              : 'category-card-desktop--details'
          }`}
        >
          <div
            className={`${
              isCategoriesLink
                ? 'desktop-categories-link--details--name'
                : 'category-card-desktop--details--name'
            }`}
          >
            {category.categoryDisplayName}
          </div>
          {/* {isCategoriesLink && (
            <div className="desktop-categories-link--icon">
              <Icon size={13} class="icon-common-black-arrow-right" />
            </div>
          )} */}
        </div>
      </div>
    </Fragment>
  );
};

export default CategoryCard;
